import React from "react";
import { FormattedMessage } from "react-intl";
import { FetchStatus } from "../commons/Constants";
import SearchIcon from "@ux/icon/search";
import ChevronRightIcon from "@ux/icon/chevron-right";
import classes from "./RollerAdsContent.module.scss";

interface RollerAdsKeywordLinksProps {
  keywords: string[];
  fetchState: number;
  onKeywordClick: (keyword: string) => void;
}

export const RollerAdsKeywordLinks: React.FC<RollerAdsKeywordLinksProps> = ({
  keywords,
  fetchState,
  onKeywordClick,
}) => (
  <div className={ classes.rollerAdsKeywords }>
    <div className={ classes.header }>
      <span>
        <FormattedMessage
          id="rollerAdsKeywordsHeading"
          defaultMessage="Related Searches"
        />
      </span>
    </div>
    <ul>
      {keywords.map((keyword) => (
        <li key={ keyword }>
          <div className={ classes.iconContainer }>
            <SearchIcon style={{ color: "black" }} height="32" width="32" />
          </div>
          <button
            type="button"
            className={ classes.keywordButton }
            onClick={ () => onKeywordClick(keyword) }
          >
            {keyword}
          </button>
          <div style={{ minWidth: "32px" }}>
            <ChevronRightIcon
              style={{ color: "black" }}
              height="32"
              width="32"
            />
          </div>
        </li>
      ))}
    </ul>
    {fetchState === FetchStatus.FAILURE && (
      <div>
        <FormattedMessage id="contentBlockedText" />
      </div>
    )}
  </div>
);
